export const debug = process.env.REACT_APP_DEBUG === "true";
